import { Anchor, Box, Text } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';

import { EXTERNAL_URLS } from '../../constants/urls';

import type { ReactNode } from 'react';

type Props = {
  actionText: string;
  isTextCenter?: boolean;
  isNotFlatFee?: boolean;
  displayPrice?: string;
  useFreemiumValues?: boolean;
  previewListingCTA?: ReactNode;
  isLoading?: boolean;
};

const ListingActivationTerms = ({
  actionText,
  isTextCenter = false,
  isNotFlatFee = false,
  displayPrice = '',
  useFreemiumValues = false,
  previewListingCTA,
  isLoading = false,
}: Props) => {
  const renderBaseContent = () => {
    return (
      <>
        {actionText}, you agree to comply with our&nbsp;
        <Anchor href={EXTERNAL_URLS.CORP_TERMS} target="_blank" rel="noopener noreferrer">
          Terms of Use
        </Anchor>
        ,&nbsp;
        <Anchor href={EXTERNAL_URLS.RENTAL_USER_TERMS} target="_blank" rel="noopener noreferrer">
          Rental User Terms
        </Anchor>
        , and&nbsp;
        <Anchor href={EXTERNAL_URLS.PLEDGE} target="_blank" rel="noopener noreferrer">
          Respectful Renting Pledge
        </Anchor>
        .
      </>
    );
  };

  const renderFreemiumDisabledContent = () => {
    return (
      <>
        {isNotFlatFee ? (
          <>
            {actionText}, you agree you are purchasing a continuous subscription and will be charged&nbsp;
            {displayPrice}
            &nbsp;until you cancel and to comply with our&nbsp;
            <Anchor href={EXTERNAL_URLS.PLEDGE} target="_blank" rel="noopener noreferrer">
              Respectful Renting Pledge
            </Anchor>
            . Cancel anytime by deactivating your listing. For more information see our&nbsp;
            <Anchor href={EXTERNAL_URLS.CORP_TERMS} target="_blank" rel="noopener noreferrer">
              Terms of Use
            </Anchor>
            &nbsp;and&nbsp;
            <Anchor href={EXTERNAL_URLS.RENTAL_USER_TERMS} target="_blank" rel="noopener noreferrer">
              Rental User Terms
            </Anchor>
            .
          </>
        ) : (
          renderBaseContent()
        )}
      </>
    );
  };

  if (previewListingCTA) {
    return (
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text textStyle="fineprint">{useFreemiumValues ? renderBaseContent() : renderFreemiumDisabledContent()}</Text>

        {previewListingCTA}
      </Box>
    );
  }

  return (
    <Box
      data-testid="listing-activation-terms"
      className="fs-unmask"
      css={{ textAlign: isTextCenter ? 'center' : 'left' }}
    >
      <LoadingText isLoading={isLoading} textStyle="fineprint">
        {useFreemiumValues ? renderBaseContent() : renderFreemiumDisabledContent()}
      </LoadingText>
    </Box>
  );
};

export default ListingActivationTerms;
